import { Link } from "react-router-dom";
import {motion} from 'framer-motion'

import { IoMdArrowDropdown } from "react-icons/io";
import {  useState } from "react";

// Products dropdown items
const product_items = [
    {
        title: 'PIPES',
        to: `/products/pipes`,
    },
    {
        title: 'FLANGES',
        to: `/products/flanges`,
    },
    {
        title: 'VALVES',
        to: `/products/valves`,
    },
    // {
    //     title: 'SUPPORTS',
    //     to: `/products/supports`,
    // },
];

// Industries We Serve dropdown items
const industry_items = [
    {
        title: 'FIRE FIGHTING',
        to: `/product_list/firefighting`,
    },
    {
        title: 'PLUMBING',
        to: `/product_list/plumbing`,
    },
    {
        title: 'HVAC',
        to: `/product_list/hvac`,
    },
    {
        title: 'OIL & GAS',
        to: `/product_list/gas`,
    },
    {
        title: 'PROCESS INDUSTRIES',
        to: `/product_list/process`,
    },
];

const ListComponent = ({clicked, handleNavLinkClick, items}) => {
    return (
        <ul className={`absolute flex flex-col gap-1 pt-0 mt-6 md:mt-0 md:py-3 bg-primary text-white md:bg-white md:text-black p-3 w-64 md:w-52 top-8 right-0 md:left-0 transform scale-0 ${clicked?"scale-100":"scale-0"} md:group-hover:scale-100 transition duration-150 ease-in-out origin-top shadow-lg rounded-s-xl md:rounded-e-xl pb-3 z-50`}>
            {items.map((item, index) => (
                <Link key={index} to={item.to} onClick={()=>handleNavLinkClick()} className="">
                    <li className=" text-lg rounded-2xl md:text-sm md:text-black hover:bg-slate-100 leading-0 md:leading-8 ps-5 md:px-3">
                        <p className=" ">{item.title}</p>
                    </li>
                </Link>
            ))}
        </ul>
    );
};

const Dropdown = ({title, items, location, clicked, handleNavLinkClick})=>{
    return(
    <>
        <li className="flex relative group z-10 bg-primary rounded-s-xl cursor-pointer">
        <div className="flex">
        <p className="mr-1 text-lg  ps-5 pe-3 md:py-2 font-inter font-medium  text-navText md:text-sm lg:py-1.5 py-1 lg:px-4 px-2 rounded-full   gap-2">
            {title}
            {location===title.toLowerCase().replace(/\s+/g, '-')?<motion.div layoutId="underline" className=" bg-navTextActive h-[1px]" /> : null}
        </p>
        <IoMdArrowDropdown fill="white" size={20} className={`my-auto md:hover:rotate-180 ${clicked?"rotate-180":""}`}/>
        </div>
        <ListComponent clicked={clicked} handleNavLinkClick={handleNavLinkClick} items={items} />
        </li>
    </>)
}
const NavLinks = [
    {
        title:"Home",
        to:"/",
    },
    // {
    //     title:"Products",
    //     to:"/products",
    // },
    {
        title:"About Us",
        to:"/about",
    },
    {
        title:"Certificates",
        to:"/certificates",
    },
]
const Navbar = ({location})=>{

    const [isProductsClicked, setProductsClicked] = useState(false);
    const [isIndustriesClicked, setIndustriesClicked] = useState(false);

    const handleNavLinkClick = () => {
      // Close the menu when a NavLink is clicked
      document.getElementById('check').checked = false;
      setProductsClicked(false);
      setIndustriesClicked(false);
    };
    return(
        <>
        <div className="hidden md:flex flex-row justify-between bg-primary w-full xl:px-32 lg:px-20 md:px-16 px-5 py-10" >
        {/* absolute top-0 left-1/2  -translate-x-1/2 */}
            <Link className=" flex gap-2 items-center" to={"/"}>
                <img width={80} className="" src="/images/icons/logo2.png" alt="logo" />
                {/* {location==="/"?<p className={`capitalize font-abel font-bold md:text-2xl text-2xl text-white`}> City Industrial Traders</p>:<></>} */}
            </Link>
            <div className="md:flex md:gap-4 gap-2 justify-center content-center items-center hidden text-primary">
            {NavLinks.map((item,index)=>{
                return(
                        <Link key={index} to={item.to} className="flex flex-col gap-2">
                            {/* <div className= {`${isAbout?"text-primary hover:text-white hover:bg-primary border-primary":"border-white text-white hover:text-primary hover:bg-white"} text-xs  lg:py-1.5 py-1  lg:px-4 px-2 rounded-full border cursor-pointer`}> */}
                            <div  className= {`${location===item.to?"text-navTextActive":"text-navText"} text-sm  lg:py-1.5 py-1  lg:px-4 px-2 rounded-full  cursor-pointer gap-2`}>
                                {item.title}

                                {location===item.to?<motion.div layoutId="underline" className=" bg-navTextActive h-[1px]" /> : null}
                            </div>
                        </Link>
                )
            })}
                        <Dropdown title="Products" items={product_items} handleNavLinkClick={handleNavLinkClick}/>
                        <Dropdown title="Industries We Serve" items={industry_items} handleNavLinkClick={handleNavLinkClick}/>
            </div>
            <div className="flex justify-center items-center ">
                <Link to={"/contact"} className="flex text-navbar px-5 py-2.5 items-center justify-center gap-2 bg-navTextActive rounded-3xl">
                    <img width={20} src="/images/icons/phone.svg" alt='icon' />
                    <p className="text-navbar text-sm font-bold">Contact Us</p>
                </Link>
            </div>
        </div>
        
        {/* Mobile Nav */}
        <header>
            <nav className="md:hidden w-full z-20 bg-primary">
                <ul className="navigation max-w-[90vw] flex flex-wrap justify-between items-center relative mx-auto py-8">
                    <Link to={"/"} className="logo flex gap-3">
                        <img style={{fill:"#000"}} width={60} className="" src="/images/icons/logo2.png" alt="logo" /><p className={` sm:block hidden capitalize font-abel font-bold md:text-3xl text-2xl text-white`}> City Industrial Traders</p>
                    </Link>
                <input type="checkbox" id="check" />

                <span className="menu flex flex-col w-full justify-end items-end px-10 xl:[&>li]:pl-8 md:[&>li]:pl-3 [&>li>a]:text-end [&>li>a]:relative [&>li>a]:transition [&>li>a]:duration-200 [&>li>a]:ease-in-out [&>li>a]:font-medium">
                {NavLinks.map((item,index)=>{
                    return(
                        <li key={index}><Link to={item.to} onClick={() => {handleNavLinkClick()}} className="text-lg bg-primary ps-5 rounded-s-xl pe-3 py-2 text-white font-inter font-bold">{item.title}</Link></li>
                    )
                })}
                <div onClick={()=>{setProductsClicked(!isProductsClicked); setIndustriesClicked(false);}} className="mb-1">
                    <Dropdown title="Products" items={product_items} clicked={isProductsClicked} handleNavLinkClick={handleNavLinkClick}/>
                </div>
                <div onClick={()=>{setIndustriesClicked(!isIndustriesClicked); setProductsClicked(false);}} className={`mb-1 transition-all duration-200 ${isProductsClicked ? 'mt-28' : ''}`}>
                    <Dropdown title="Industries We Serve" items={industry_items} clicked={isIndustriesClicked} handleNavLinkClick={handleNavLinkClick}/>
                </div>

                    <label htmlFor="check" className="text-white rounded-s-xl bg-primary text-end close-menu me-5 ps-5 pe-3 py-1 mt-2.5 text-3xl">X</label>
                </span>
                <label htmlFor="check" className="open-menu">
                    <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24 0H0V2.18182H24V0Z" fill="#ffff"/>
                    <path d="M24 9.81818H0V12H24V9.81818Z" fill="#ffff"/>
                    <path d="M24 19.6364H0V21.8182H24V19.6364Z" fill="#ffff"/>
                    </svg>
                </label>
                </ul>
            </nav>
            </header>
            </>
    )
}

export default Navbar;